<template>
  <div class="tw-max-w-3xl md:tw-m-auto">
    <modal
      class="tw-flex tw-flex-col tw-justify-center tw-bg-black tw-opacity-100"
      v-if="confirmationdialog"
    >
      <div title="Submit Team List" style="width: 80%" class="tw-p-3 tw-mx-auto tw-bg-white">
        <div class="tw-mb-6 tw-text-center">
          Submitting this team list will override existing one. Do you want to continue?
        </div>
        <button
          type="success"
          class="tw-justify-center tw-w-full tw-py-4 tw-mb-2.5 sm:tw-mr-4 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-uppercase tw-bg-green-700 tw-px-auto hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64"
          size="small"
          @click="submitTeamList(false)"
        >
          Submit
        </button>
        <button
          type="primary"
          class="tw-justify-center tw-w-full tw-py-4 tw-mb-2.5 sm:tw-mr-4 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-uppercase tw-bg-green-700 tw-px-auto hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64"
          size="small"
          @click="submitTeamList(true)"
        >
          Submit & Score
        </button>
        <button
          size="small"
          class="tw-justify-center tw-w-full tw-h-10 tw-text-sm sm:tw-mr-4 tw-not-italic tw-font-medium tw-tracking-normal tw-text-center tw-text-black tw-uppercase tw-bg-gray-200 tw-border-2 tw-border-green-700 tw-rounded-lg tw-leading-11px hover:tw-border-gray-200 sm:tw-w-64"
          @click="confirmationdialog = false"
        >
          Cancel
        </button>
      </div>
    </modal>

    <div class="tw-mb-3" v-if="showList">
      <div class="tw-flex tw-flex-col tw-text-lg tw-font-medium tw-text-center tw-text-black">
        <div class="tw-p-2 tw-h-9 md:tw-tracking-wider">
          <!-- Competition: -->
          {{ (match && match.competition && match.competition.name) || "" }}
        </div>
        <div
          class="tw-p-2 tw-tracking-wider tw-h-9"
          v-if="team && team.orgtree && team.orgtree.club && team.orgtree.club.name"
        >
          <!-- Club: -->
          {{ team && team.orgtree && team.orgtree.club && team.orgtree.club.name }}
        </div>
        <div class="tw-p-2 tw-tracking-wider tw-h-9" v-else>
          <!-- Club: -->
          {{ team && team.name }}
        </div>
        <div
          class="tw-uppercase tw-text-sm tw-leading-3 tw-h-9 md:tw-p-2.5 tw-px-0 tw-py-2.5 md:tw-tracking-widest tw-tracking-wider"
        >
          <!-- Match: -->
          {{ (match && formatMatchDateTime(match.dateTime)) || "" }}
        </div>
      </div>
    </div>

    <div class="tw-flex tw-justify-center tw-mb-9" v-if="showList">
      <div class="tw-flex tw-text-xs">
        <input class="tw-hidden" id="players" type="radio" v-model="isPlayerScreen" :value="true" />
        <label
          class="tw-h-8 tw-py-2 tw-text-center tw-rounded-l-lg tw-w-28 hover:tw-bg-green-300 hover:tw-text-black"
          :class="{
            'tw-bg-green-700 tw-text-white': isPlayerScreen,
            'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200': !isPlayerScreen,
          }"
          for="players"
          >Players</label
        >
        <input
          class="tw-hidden"
          id="officials"
          type="radio"
          v-model="isPlayerScreen"
          :value="false"
        />
        <label
          class="tw-h-8 tw-py-2 tw-text-center tw-rounded-r-lg tw-w-28 hover:tw-bg-green-300 hover:tw-text-black"
          :class="{
            'tw-bg-green-700 tw-text-white': !isPlayerScreen,
            'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200': isPlayerScreen,
          }"
          for="officials"
          >Officials</label
        >
      </div>
    </div>
    <modal v-if="teamlist.players.length > 0 && teamListCards.players && showingPlayerCards">
      <player-card
        :isPlayer="true"
        :players="teamListCards.players"
        :competition="teamListCards.competition"
        :team="teamListCards.team"
        :club="teamListCards.club"
        @close="showingPlayerCards = false"
      />
    </modal>

    <modal
      class="tw-flex tw-flex-col tw-justify-end tw-bg-gray-200 tw-bg-opacity-50"
      v-if="teamlist.players.length > 0 && teamListCards.players && replacePlayerModal"
    >
      <replace-player
        :playerToChange="playerSelected"
        :availablePlayersToAdd="availablePlayersToAdd"
        :positionsList="positionsList"
        @changedPlayer="updatePlayerList"
        @close="handleModalClose"
      />
    </modal>

    <modal
      v-if="teamlist.nonplayers.length > 0 && teamListCards.nonplayers && showingNonPlayerCards"
    >
      <player-card
        :isPlayer="false"
        :players="teamListCards.nonplayers"
        :competition="teamListCards.competition"
        :team="teamListCards.team"
        :club="teamListCards.club"
        @close="showingNonPlayerCards = false"
      />
    </modal>

    <!-- Players Screen -->
    <div v-show="isPlayerScreen">
      <form
        id="playerForm"
        method="post"
        action="/textLabels"
        accept-charset="UTF-8"
        @submit.prevent="addPlayer"
        v-if="showList"
      >
        <div prop="_id" class="tw-px-2 tw-mb-5">
          <select
            id="sel-player"
            v-model="playerForm._id"
            :class="playerForm._id ? 'tw-font-medium ' : 'tw-font-normal'"
          >
            <option disabled :value="null">Select Player</option>
            <option v-for="{ profile, _id, name } in availablePlayersToAdd" :value="_id" :key="_id">
              {{ name }}
            </option>
          </select>
        </div>
        <div prop="position" class="tw-px-2 tw-mb-5">
          <select
            v-model="playerForm.position"
            :class="playerForm.position ? 'tw-font-medium ' : 'tw-font-normal'"
          >
            <option disabled :value="null">Select Position</option>
            <option
              v-for="position in positionsList"
              :label="`${position.name} #${position.number}`"
              :value="position.number"
              :key="position.number"
            >
              {{ position.name }}
            </option>
          </select>
        </div>
        <div id="row" class="tw-grid tw-grid-cols-2 tw-gap-4 tw-px-2">
          <input
            id="sel-number"
            class="tw-w-full tw-px-2 tw-text-sm tw-font-normal tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none"
            :controls="false"
            v-model="playerForm.shirtNum"
            placeholder="Select Number"
            :class="playerForm.shirtNum ? 'tw-font-medium ' : 'tw-font-normal'"
          />
          <select
            v-model="playerForm.isCaptain"
            :class="playerForm.isCaptain ? 'tw-font-medium ' : 'tw-font-normal'"
          >
            <option :value="true">Captain (C)</option>
            <option :value="false">Select Captaincy</option>
          </select>
        </div>

        <div class="tw-flex tw-justify-center">
          <button
            type="submit"
            class="tw-justify-center tw-w-full tw-mt-8 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 tw-mb-8 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-72"
          >
            Add Player
          </button>
        </div>
      </form>

      <div>
        <strong v-if="teamlist.previous"> Previous Team List </strong>

        <div class="tw-pb-3.5 tw-text-sm tw-font-medium tw-tracking-widest tw-leading-3">
          LATEST PLAYER LIST
        </div>

        <div class="tw-w-full tw-p-0 tw-px-2 tw-py-2 tw-pb-5 tw-m-0 tw-bg-white">
          <div class="tw-grid tw-grid-cols-4 tw-gap-5 tw-mb-2.5">
            <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">NAME</div>
            <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">POSITION</div>
            <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">SHIRT #</div>
            <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">ACTIONS</div>
          </div>
          <div
            class="tw-grid tw-grid-cols-4 tw-gap-5 tw-mb-3"
            v-for="player in sortBy(teamlist.players, ['position.order'])"
            :key="player._id"
          >
            <div v-if="player.profile" class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">
              <div>{{ displayPlayerPreferFirstName(player.profile) }}</div>
              <div>{{ displayPlayerPreferLastName(player.profile) }}</div>
            </div>
            <div v-else>{{ "N/A" }}</div>
            <div class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">
              {{ player.position.name.toUpperCase() }}
              <span v-if="player.isCaptain">(C)</span>
            </div>

            <input
              class="tw-w-full tw-pl-1 tw-text-xs tw-font-normal tw-leading-3 tw-text-left tw-border tw-border-gray-200 focus:tw-outline-none"
              :controls="false"
              v-if="player.shirtNum !== null"
              v-model="player.shirtNum"
              @keyup="updateShirtNumber"
            />

            <div class="tw-flex tw-flex-row tw-items-center tw-col-span-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-5 tw-h-5 tw-mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                @click="replacePlayer(player)"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-5 tw-h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                @click="removePlayer(player)"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Team Officials Screen  -->
    <div id="el-row-official" v-show="!isPlayerScreen">
      <form id="nonplayerForm" method="post" action="/textLabels" accept-charset="UTF-8">
        <div prop="role" class="tw-px-2 tw-mb-5">
          <select
            v-model="nonplayerForm.role"
            :class="nonplayerForm.role ? 'tw-font-medium' : 'tw-font-normal'"
          >
            <option disabled :value="null">Select Role</option>
            <option
              v-for="{ type, name } in nonPlayerRoles"
              :key="type"
              :label="name"
              :value="type"
            >
              {{ name }}
            </option>
          </select>
        </div>
        <div prop="_id" class="tw-px-2">
          <select
            v-model="nonplayerForm._id"
            :class="nonplayerForm._id !== null ? 'tw-font-medium' : 'tw-font-normal'"
          >
            <option disabled :value="null">Select Official</option>
            <option
              v-for="{ profile, _id, name } in availableNonPlayersToAdd"
              :label="name"
              :value="_id"
              :key="_id"
            >
              {{ name }}
            </option>
          </select>
        </div>

        <div class="tw-flex tw-justify-center">
          <button
            type="submit"
            @click.prevent="addnonplayer"
            class="tw-justify-center tw-w-full tw-mt-8 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 tw-mb-8 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-72"
          >
            Add
          </button>
        </div>
      </form>

      <div id="el-row-off1">
        <strong v-if="teamlist.previous"> Previous Team List </strong>

        <div class="tw-pb-3.5 tw-text-sm tw-font-medium tw-tracking-widest tw-leading-3">
          OFFICIALS
        </div>

        <div class="tw-w-full tw-p-0 tw-px-2 tw-py-2 tw-pb-5 tw-m-0 tw-bg-white">
          <div class="tw-grid tw-grid-cols-3 tw-gap-5 tw-mb-3">
            <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">NAME</div>
            <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">ROLE</div>
            <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">ACTIONS</div>
          </div>
          <div v-if="teamlist.nonplayers.length > 0">
            <div
              class="tw-grid tw-grid-cols-3 tw-gap-5 tw-mb-3"
              v-for="nonplayer in sortBy(teamlist.nonplayers, ['firstName', 'lastName'])"
              :key="nonplayer._id"
            >
              <div
                v-if="nonplayer.profile"
                class="tw-w-1/4 tw-text-xs tw-font-normal tw-leading-3 tw-text-left"
              >
                <div>{{ displayPlayerPreferFirstName(nonplayer.profile) }}</div>
                <div>{{ displayPlayerPreferLastName(nonplayer.profile) }}</div>
              </div>
              <div v-else>{{ "N/A" }}</div>
              <div
                class="tw-w-1/4 tw-text-xs tw-font-normal tw-leading-3 tw-text-left tw-uppercase"
              >
                {{
                  (nonPlayerRoles.find((x) => x.type === nonplayer.role) &&
                    nonPlayerRoles.find((x) => x.type === nonplayer.role).name) ||
                  "N/A"
                }}
              </div>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="tw-w-5 tw-h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  @click="removenonplayer(nonplayer)"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div v-else class="tw-w-full tw-h-12"></div>
        </div>
      </div>
    </div>

    <!-- <div class="tw-mt-0 tw-mb-0 tw-bg-white"></div> -->
    <div class="sm:tw-flex sm:tw-justify-center">
      <div v-if="isPlayerScreen" class="sm:tw-mr-4">
        <button
          type="default"
          @click="doPlayerCardDisplay"
          class="tw-justify-center tw-w-full sm:tw-mt-8 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-border-2 tw-bg-none hover:tw-border-green-300 tw-border-green-700 sm:tw-w-72"
        >
          View Player Cards
        </button>
      </div>
      <div v-if="!isPlayerScreen" class="sm:tw-mr-4">
        <button
          type="default"
          @click="doNPCardDisplay"
          class="tw-justify-center tw-w-full sm:tw-mt-8 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-border-2 tw-bg-none hover:tw-border-green-300 tw-border-green-700 sm:tw-w-72"
        >
          Cards
        </button>
      </div>
      <div v-if="showList">
        <button
          @click="confirmationdialog = true"
          class="tw-justify-center tw-w-full tw-mt-4 sm:tw-mt-8 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 tw-mb-8 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-72"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import _, { sortBy } from "lodash";
import Modal from "@/components/Modal.vue";
import PlayerCard from "@/components/PlayerCard.vue";
import ReplacePlayer from "@/components/ReplacePlayer.vue";
import { errormsg, nonPlayerRoles, currentSeason } from "../../utils/constants";

const formatWithName = (pl) => {
  const preferFirstName = pl.profile.preferNameStatus
    ? pl.profile.preferFirstName || pl.profile.firstName
    : pl.profile.firstName;
  const preferLastName = pl.profile.preferNameStatus
    ? pl.profile.preferLastName || pl.profile.lastName
    : pl.profile.lastName;
  const name = `${preferFirstName} ${preferLastName}`;
  return name;
};

export default {
  name: "TeamList",
  components: { PlayerCard, Modal, ReplacePlayer },
  data() {
    return {
      sortBy,
      confirmationdialog: false,
      showingPlayerCards: false,
      showingNonPlayerCards: false,
      isPlayerScreen: true,
      positions: [],
      nonPlayerRoles,
      players: [],
      nonplayers: [],
      team: null,
      match: null,
      permissionedMatch: false,
      playerForm: {
        _id: null,
        position: null,
        shirtNum: null,
        firstName: "",
        middleName: null,
        lastName: "",
        isPrivate: false,
        isCaptain: false,
      },
      resetPlayerForm: {
        _id: null,
        position: null,
        shirtNum: null,
        firstName: "",
        middleName: null,
        lastName: "",
        isPrivate: false,
        isCaptain: false,
      },
      playerFormRules: {
        _id: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        position: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        shirtNum: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
        },
      },
      nonplayerForm: {
        role: null,
        firstName: "",
        middleName: "",
        lastName: "",
        isPrivate: false,
        _id: null,
      },
      resetNonplayerForm: {
        role: null,
        firstName: "",
        middleName: "",
        lastName: "",
        isPrivate: false,
        _id: null,
      },
      nonplayerRules: {
        _id: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        role: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
      },
      teamlist: {
        _id: null,
        season: currentSeason,
        matchid: "",
        isHomeTeam: false,
        team: {
          _id: null,
          name: "",
        },
        competition: {
          _id: null,
          name: "",
        },
        players: [],
        nonplayers: [],
        status: "final",
      },
      teamListCards: {},
      replacePlayerModal: false,
      playerSelected: {},

      showList: true,

      showSelectName: false,
    };
  },
  mounted() {
    const { matchId, teamId } = this.$route.params;
    this.teamlist.matchid = +matchId;
    this.$store.commit("root/loading", true);

    Promise.all([
      this.$http.get(`nrl/api/v1/admin/matches/${this.teamlist.matchid}`),
      this.$http.get(`nrl/api/v1/admin/teams/${teamId}`),
    ])
      .then(([matchRes, teamRes]) => {
        this.match = matchRes.data.data;
        this.team = teamRes.data.data;

        // check if tba or bye match return to team list
        if (this.match && this.match.meta && (this.match.meta.isTba || this.match.meta.isBye)) {
          this.$router.push("/team-lists");
          return;
        }

        this.teamlist.team._id = teamRes.data.data._id;
        this.teamlist.team.name = teamRes.data.data.name;
        this.teamlist.team.logo = teamRes.data.data.meta ? teamRes.data.data.meta.avatar : "";
        if (teamRes.data.data.orgtree.national._id === 32 && teamRes.data.data.orgtree?.club?.name)
          this.teamlist.team.clubName = teamRes.data.data.orgtree.club.name;

        // get players, non-players, positions by competition settings
        Promise.all([
          this.$http.get(
            `/nrl/api/v1/admin/teamlists/players/${this.teamlist.team._id}?match=${this.match._id}`
          ),
          this.$http.get(
            `/nrl/api/v1/admin/teamlists/nonplayers/${this.teamlist.team._id}?match=${this.match._id}`
          ),
          this.$http.get(
            `/nrl/api/v1/admin/competitions-settings/competition/${this.match.competition._id}`
          ),
          this.$http.get(`/nrl/api/v1/admin/matches/${this.match?._id}/permissioned-association`),
        ])
          .then(([playersRes, nonPlayersRes, compSettingsRes, permissionsRes]) => {
            this.players = playersRes.data.data;
            this.nonplayers = nonPlayersRes.data.data;

            this.positions = compSettingsRes.data.data.positions;
            this.permissionedMatch = permissionsRes?.data?.data?.permissioned_teamlist;
            // formatWithName
            this.teamlist.isHomeTeam = this.match.homeTeam._id === this.teamlist.team._id;

            this.$http
              .get(
                `/nrl/api/v1/admin/teamlists/teams/${this.teamlist.team._id}/matches/${this.teamlist.matchid}`
              )
              .then((teamListRes) => {
                if (teamListRes.data.data && teamListRes.data.data.length > 0) {
                  // eslint-disable-next-line prefer-destructuring
                  const [teamlist] = teamListRes.data.data;
                  this.teamlist = teamlist;
                  this.$http
                    .get(`/nrl/api/v1/admin/teamlists/${this.teamlist._id}/cards`)
                    .then((cardRes) => {
                      this.teamListCards = cardRes.data.data;
                      this.$store.commit("root/loading", false);
                    })
                    .catch(() => {
                      this.$store.commit("root/loading", false);
                    });
                } else {
                  this.$http
                    .get(
                      `/nrl/api/v1/admin/teamlists/teams/${this.teamlist.team._id}/competitions/${this.match.competition._id}/previous`
                    )
                    .then((prevList) => {
                      if (prevList.data.data && prevList.data.data.length) {
                        const [teamlist] = prevList.data.data;
                        this.teamlist = Object.assign({}, this.teamlist, teamlist);
                      }
                    });
                }

                this.$store.commit("root/loading", false);
              })
              .catch(() => {
                this.$store.commit("root/loading", false);
              });
          })
          .catch(() => {
            this.$store.commit("root/loading", false);
          });
      })
      .catch(() => {
        this.$customError("An error occurred");
        this.$store.commit("root/loading", false);
      });
  },
  methods: {
    doPlayerCardDisplay() {
      if (this.teamListCards.players && this.teamListCards.players.length > 0) {
        this.showingPlayerCards = true;
      } else {
        this.$customError("Please submit a teamlist to see player cards");
      }
    },
    doNPCardDisplay() {
      if (this.teamListCards.nonplayers && this.teamListCards.nonplayers.length > 0) {
        this.showingNonPlayerCards = true;
      } else {
        this.$customError("Please submit a teamlist to see non-player cards");
      }
    },
    updateShirtNumber: _.debounce(function debouncedInput() {
      this.$customSuccess("Please resubmit team list to save your changes");
    }, 1000),
    async addPlayer() {
      const val =
        this.playerForm._id && this.playerForm.position && this.playerForm.shirtNum ? true : false;
      if (val) {
        let player = this.players.find((x) => x._id === this.playerForm._id);
        const profile = player.profile;
        const {
          available,
          profile: { firstName, middleName, lastName, isPrivate },
        } = player;

        _.assignIn(this.playerForm, {
          firstName,
          middleName,
          lastName,
          profile,
          isPrivate: isPrivate || false,
        });

        // validate available
        if (available && available.is === false) {
          const error =
            available.notes && available.notes !== ""
              ? `${errormsg.player_unavailable} due to ${available.notes}`
              : errormsg.player_unavailable;
          this.$customError(error);
          return;
        }

        // validate duplicate position
        if (
          this.teamlist.players.some((x) => x.position.number === this.playerForm.position.number)
        ) {
          this.$customError(errormsg.same_position);
          return;
        }

        const playerFormPosition = this.positionsList.find(
          (x) => x.number === this.playerForm.position
        );
        this.playerForm.position = playerFormPosition;

        player = _.clone(this.playerForm);

        this.teamlist.players.push(player);
        this.playerForm = _.clone(this.resetPlayerForm);
      }
    },
    async addnonplayer() {
      const val = this.nonplayerForm._id && this.nonplayerForm.role ? true : false;
      if (val) {
        let nonplayer = this.nonplayers.find((x) => x._id === this.nonplayerForm._id);
        const { firstName, middleName, lastName, isPrivate } = nonplayer.profile;
        const profile = nonplayer.profile;

        _.assignIn(this.nonplayerForm, {
          firstName,
          middleName,
          lastName,
          profile,
          isPrivate: isPrivate || false,
        });

        nonplayer = _.clone(this.nonplayerForm);
        this.teamlist.nonplayers.push(nonplayer);

        this.nonplayerForm = _.clone(this.resetNonplayerForm);
      }
    },
    async submitTeamList(goToMatch = false) {
      const noShirtNum = this.teamlist.players.filter((player) => !player.shirtNum).length > 0;
      if (noShirtNum) {
        this.$customError(errormsg.no_shirt_num);
        this.confirmationdialog = false;
        return;
      }

      if (this.teamlist._id) {
        this.$store.commit("root/loading", true);
        if (this.teamlist.players.length > 0) {
          this.teamlist.players = this.teamlist.players.map((pl) => ({
            ...pl,
            preferredName: formatWithName(pl) || "",
          }));
        }
        if (this.teamlist.nonplayers.length > 0) {
          this.teamlist.nonplayers = this.teamlist.nonplayers.map((pl) => ({
            ...pl,
            preferredName: formatWithName(pl) || "",
          }));
        }
        const res = await this.$http
          .put(`/nrl/api/v1/admin/teamlists/${this.teamlist._id}`, {
            players: this.teamlist.players.map((p) => ({
              ...p,
              shirtNum: p.shirtNum ? p.shirtNum.toString() : "",
            })),
            nonplayers: this.teamlist.nonplayers,
          })
          .catch((e) => this.$customError(_.get(e, "response.data.message")))
          .finally(() => this.$store.commit("root/loading", false));

        if (!res) return;

        // navigate to match
        if (goToMatch) {
          this.$router.push({
            name: "match.detail",
            params: {
              matchId: this.teamlist.matchid,
              teamId: this.teamlist.team._id,
            },
          });
        } else {
          this.confirmationdialog = false;
          this.$customSuccess();
          this.$store.commit("root/loading", true);
          const cardRes = await this.$http.get(
            `/nrl/api/v1/admin/teamlists/${this.teamlist._id}/cards`
          );
          this.teamListCards = cardRes.data.data;
          this.$store.commit("root/loading", false);
        }
      } else {
        this.$store.commit("root/loading", true);
        const x = {
          ...this.teamlist,
          players: this.teamlist.players.map((p) => ({
            ...p,
            shirtNum: p.shirtNum ? p.shirtNum.toString() : "",
          })),
        };

        if (this.teamlist.players.length > 0) {
          this.teamlist.players = this.teamlist.players.map((pl) => ({
            ...pl,
            preferredName: formatWithName(pl) || "",
          }));
        }
        if (this.teamlist.nonplayers.length > 0) {
          this.teamlist.nonplayers = this.teamlist.nonplayers.map((pl) => ({
            ...pl,
            preferredName: formatWithName(pl) || "",
          }));
        }

        const res = await this.$http
          .post("/nrl/api/v1/admin/teamlists/", {
            ...this.teamlist,
            players: this.teamlist.players.map((p) => ({
              ...p,
              shirtNum: p.shirtNum ? p.shirtNum.toString() : "",
            })),
          })
          .catch((e) => {
            this.$customError(_.get(e, "response.data.message"));
            this.$store.commit("root/loading", false);
          });

        if (!res) return;

        this.teamlist._id = res.data.data;
        this.teamlist.previous = false;

        // navigate to match
        if (goToMatch) {
          this.$router.push({
            name: "match.detail",
            params: {
              matchId: this.teamlist.matchid,
              teamId: this.teamlist.team._id,
            },
          });
        } else {
          // open navigate to team dialog
          this.$customSuccess();
          this.confirmationdialog = false;
          this.$store.commit("root/loading", true);
          const cardRes = await this.$http.get(
            `/nrl/api/v1/admin/teamlists/${this.teamlist._id}/cards`
          );
          this.teamListCards = cardRes.data.data;
          this.$store.commit("root/loading", false);
        }
      }
    },
    removenonplayer(row) {
      this.$confirm(
        "Are you sure you want to remove this non-player from the team list",
        "Remove non-player",
        { confirmButtonText: "OK", cancelButtonText: "Cancel" }
      )
        .then(() => {
          this.teamlist.nonplayers.splice(
            this.teamlist.nonplayers.findIndex((x) => x._id === row._id),
            1
          );
        })
        .catch(() => {});
    },
    removePlayer(row) {
      this.$confirm(
        "Are you sure you want to remove this player from the team list",
        "Remove player",
        { confirmButtonText: "OK", cancelButtonText: "Cancel" }
      )
        .then(() => {
          this.teamlist.players.splice(
            this.teamlist.players.findIndex((x) => x._id === row._id),
            1
          );
        })
        .catch(() => {});
    },
    replacePlayer(row) {
      this.replacePlayerModal = true;
      this.playerSelected = row;
      this.showList = false;
    },
    handleModalClose() {
      this.replacePlayerModal = false;
      this.showList = true;
    },
    updatePlayerList(changedPlayer) {
      let oldPlayerIndex = this.teamlist.players.findIndex(
        (x) => x._id === this.playerSelected._id
      );
      if (oldPlayerIndex > -1) {
        this.teamlist.players[oldPlayerIndex] = changedPlayer;
      }
    },

    formatMatchDateTime(dateTime) {
      return this.dayjs(dateTime).format("dddd Do MMMM h:mma");
    },
    displayPlayerPreferFirstName(profile) {
      const firstName = profile.preferNameStatus
        ? profile.preferFirstName.toUpperCase() || profile.firstName.toUpperCase()
        : profile.firstName.toUpperCase();
      return firstName;
    },
    displayPlayerPreferLastName(profile) {
      const lastName = profile.preferNameStatus
        ? profile.preferLastName.toUpperCase() || profile.lastName.toUpperCase()
        : profile.lastName.toUpperCase();
      return lastName;
    },
  },
  computed: {
    availableNonPlayersToAdd() {
      // For ease of management on the front-end, NP [activeRegos] are mapped to an array of roles without the key `memberType`
      const available = this.nonplayers.map((player) => ({
        ...player,
        name: formatWithName(player),
      }));
      const list = this.teamlist.nonplayers;
      const memberType = this.nonplayerForm.role
        ? this.nonPlayerRoles.find((obj) => obj.type === this.nonplayerForm.role).memberType
        : false;
      return _.sortBy(
        available
          ? available
              .filter((p) => !list.some((pl) => pl._id === p._id))
              .filter((p) => {
                // if (this.permissionedMatch)
                //   return memberType ? p.activeRegos.memberType === memberType : false;
                return memberType ? p.activeRegos.includes(memberType) : false;
              })
          : [],
        ["profile.firstName", "profile.lastName"]
      );
    },
    availablePlayersToAdd() {
      const list = this.teamlist.players;
      const available = this.players.map((player) => ({
        ...player,
        name: formatWithName(player),
      }));

      return _.sortBy(
        available ? available.filter((p) => !list.some((pl) => pl._id === p._id)) : [],
        ["profile.firstName", "profile.lastName"]
      );
    },
    positionsList() {
      if (!this.teamlist.players) return this.positions;
      return this.positions.filter(
        (position) =>
          !this.teamlist.players.find((player) => player.position.number === position.number)
      );
    },
  },
  watch: {
    "playerForm.position": function (position) {
      if (position) {
        this.playerForm.shirtNum = position.toString();
      }
    },
    isPlayerScreen(val) {
      if (val) {
        this.nonplayerForm = this.resetNonplayerForm;
      } else {
        this.playerForm = this.resetPlayerForm;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-select,
.el-input-number-legacy {
  width: 100%;
}

.captain-icon {
  color: green;
  font-size: 2rem;
}

.remove-icon {
  color: red;
  font-size: 2rem;
}

.refresh-icon {
  color: green;
  font-size: 2rem;
}

.text-right {
  text-align: right;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

.footer-customize {
  .el-button {
    margin: 10px;
    min-width: 210px;
  }
}

::v-deep .el-input-number .el-input__inner {
  padding: 0 !important;
  font-size: 16px; // fixed zoom-in issue on ios by increasing this font-size;
}

select {
  appearance: none;
  /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg");
  /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 1px;
  padding-bottom: 8px;
  @apply tw-px-2 tw-w-full tw-text-sm tw-text-black tw-bg-transparent tw-border-b-2 tw-border-gray-200;
}

.chevron {
  background-image: url("../../assets/chevron_down.svg");
  /* Add custom arrow */
  background-position: center right;
  background-size: 40px 40px;
  background-repeat: no-repeat;
  background-position-y: 8px;
}
</style>
